import { render, staticRenderFns } from "./MeuPerfil.vue?vue&type=template&id=b7499cf6&scoped=true&"
import script from "./MeuPerfil.vue?vue&type=script&lang=js&"
export * from "./MeuPerfil.vue?vue&type=script&lang=js&"
import style0 from "./MeuPerfil.vue?vue&type=style&index=0&id=b7499cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7499cf6",
  null
  
)

export default component.exports